
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
import routes from "./routes/routes";
import packageInfo from "../package.json";

import "./registerServiceWorker";
import store from '@/store/index.js';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.use(VueRouter);
Vue.use(LightBootstrap);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.prototype.APP_NAME = packageInfo.name.toUpperCase();
Vue.prototype.APP_VERSION = `v${packageInfo.version}`;
Vue.prototype.$appName = packageInfo.name.toUpperCase();
Vue.prototype.$appVersion = `v${packageInfo.version}`;
Vue.prototype.$dev = process.env.NODE_ENV === "development";


// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  mode: "history",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.fullPath !== "/admin/login") {
      // axios
      // .post("/check/auth/token")
      // .then((res) => {
      //     console.log("Auth res", res);
      // })
      // .catch((error) => {
      //     console.log("Auth Error", error);
      //     console.log("Auth Error response", error.response);
      //     if (error && error.response.status === 401) {
      //         console.log("Authentication required!");
      //         setTimeout(() => {
      //             localStorage.removeItem("token");
      //             localStorage.removeItem("roles");
      //             localStorage.removeItem("permissions");
      //             // Clear PWA Cache on Logout
      //             caches.keys().then((cacheNames) => {
      //                 cacheNames.forEach((cacheName) => {
      //                     caches.delete(cacheName);
      //                 });
      //             });
      //             // Also Unregister ServiceWorker on Logout
      //             if (window.navigator && navigator.serviceWorker) {
      //                 navigator.serviceWorker
      //                     .getRegistrations()
      //                     .then(function (registrations) {
      //                         for (let registration of registrations) {
      //                             registration.unregister();
      //                         }
      //                     });
      //             }
      //             store.dispatch("user", null);
      //             Vue.swal.close();
      //             Vue.toasted
      //                 .show("Please Login to continue!")
      //                 .goAway(6000);
      //             setTimeout(() => {
      //                 router.push("/login");
      //             }, 500);
      //         }, 2500);
      //     }
      // });
    }
    document.title = to.meta.title || "eMenu Dashboard";
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (store.getters.user) {
      next();
      return;
    }
    next("/admin/login");
    document.title = "eMenu Dashboard | Login";
  } else {
    next();
  }
});

///* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  store,
  router
});
